import { Button } from '@hub/shared'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import './campaign-list-header.component.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  icon?: any
  title: string
  subTitle?: string
  route?: string
}

export default ({ className = '', style = {}, id = '', title = '', subTitle = '', icon, route }: Props) => {
  const [t] = useTranslation('campaignListHeader')
  const navigate = useNavigate()

  const redirect = () => {
    navigate(route?.startsWith('/') ? route : `/${route}`)
  }

  return (
    <section className={`campaign-list-header display-flex justify-content-space-between ${className}`} style={style} id={id}>
      <div>
        <h5 className="m-0" title={title}>
          {icon ? <span className="wrapper-icon">{icon}</span> : null} {title}
        </h5>
        {subTitle ? <p style={{ color: 'var(--gray)', fontSize: '0.85rem' }}>{subTitle}</p> : null}
      </div>
      <div className="button-header display-flex align-items-center">
        {route ? (
          <Button onClick={redirect} size="sm" color="transparent" textColor="var(--primary_color)" rounded style={{ minWidth: 83 }}>
            <span>{t('seeAll')}</span>
          </Button>
        ) : null}
      </div>
    </section>
  )
}
